import { render } from "./StudentMaster.vue?vue&type=template&id=5ef3918e&scoped=true"
import script from "./StudentMaster.vue?vue&type=script&lang=js"
export * from "./StudentMaster.vue?vue&type=script&lang=js"

import "./StudentMaster.vue?vue&type=style&index=0&id=5ef3918e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef3918e"]])

export default __exports__